export default "__VITE_ASSET__CtXGwCMu__"